import { useRef, useState } from "react"
import "../elements/Element.css"
import ElementsMenu from "../element-options-menu/ElementsMenu"
import suffixes from "../jmdict/processed/suffixes.json"
import AddButton from "../components/AddButton"
import JapaneseText from "../components/JapaneseText"

export default function Suffix({ element, updateElement, deleteElement, mouse, color, disabled }) {
	const [isModalOpen, setIsModalOpen] = useState()
	const elementRef = useRef(null)
	const suffixOptions = suffixes

	return (
		<div className="modalContainer">
			{!disabled && (
				<ElementsMenu
					anchorRef={elementRef}
					isModalOpen={isModalOpen}
					setIsModalOpen={setIsModalOpen}
					elementOptions={suffixOptions}
					onSelect={updateElement}
					deleteElement={deleteElement}
					hasDelete={true}
					menuTitle="Suffix"
				/>
			)}
			{element ? (
				<div
					ref={elementRef}
					className={`baseInsideElement suffixPrefixElement ${
						disabled ? "baseInsideElementLocked" : ""
					}`}
					style={{ backgroundColor: color }}
					onClick={() => {
						if (!disabled) setIsModalOpen(true)
					}}
				>
					<JapaneseText text={element.text} reading={element.textKana} />
				</div>
			) : (
				<AddButton
					mouse={mouse}
					elementOptions={suffixOptions}
					addElement={updateElement}
					hasSearch={true}
					text="suffix"
					disabled={disabled}
				/>
			)}
		</div>
	)
}
